import BannerAdsComponent from "./banner-ads.component";

export default BannerAdsComponent;
